import React, { useEffect, useState, useRef } from 'react';
import Navbar from '../Miscellaneous/Navbar';
import ShopKeyPoints from '../Miscellaneous/ShopKeyPoints';
import BackGroImg from '../Miscellaneous/BackGroImg';
import { laptopImages, mobileImages } from '../Miscellaneous/ImagesJson';
import Footer from '../Miscellaneous/Footer';
import Thankyou from '../Miscellaneous/Thankyou';
import SweetToast from '../Miscellaneous/SweetToast';

const Aboutus = () => {

  document.title = "Home - Roop Sweets";

  const [currentIndex, setCurrentIndex] = useState(0);
  const [images, setImages] = useState(laptopImages);
  const infodivRef = useRef(null);
  const [toastOpen, setToastOpen] = useState(false);

  useEffect(() => {
    const updateImages = () => {
      if (window.innerWidth <= 500) {
        setImages(mobileImages);
      } else {
        setImages(laptopImages);
      }
    };

    updateImages();
    window.addEventListener('resize', updateImages);

    return () => window.removeEventListener('resize', updateImages);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      },
    );

    if (infodivRef.current) {
      observer.observe(infodivRef.current);
    }

    return () => {
      if (infodivRef.current) {
        observer.unobserve(infodivRef.current);
      }
    };
  }, []);


  useEffect(() => {
    // show 1s after load
    const t = setTimeout(() => setToastOpen(true), 1000);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <Navbar />

      {/* <SweetToast
        open={toastOpen}
        onClose={() => setToastOpen(false)}
        message="✨ Special Desi Ghee Imarti Available!"
        duration={6000}
        icon="🍯"
      /> */}

      <div>

        <div className='outeraboutusdivmost'>

          <div className="outeraboutusdiv">
            {images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Slide ${index + 1}`}
                className={`slider-media ${index === currentIndex ? 'active' : 'inactive'}`}
              />
            ))}
          </div>

        </div>

        <div className='otherdeco'>
          <img className='decoimg11' src="/images/f3.png" alt="" />
          <img className='decoimg21' src="/images/f4.png" alt="" />
        </div>

        <div className='aboutusdiv'>

          <div className='infoWithBagdiv'>
            {/* <img src="images/namaste.png" className='aboustbagimg' alt="" /> */}
            <img src="images/namasteN.png" className='aboustbagimg' alt="" />
            <div className='infodiv' ref={infodivRef}>
              <div className='wlcmh1div'>
                {/* <p className='wlcmh1sec'>Hello!</p>
                <h1 className='wlcmh1'>Welcome to our Shop!</h1> */}
                {/* <img className='wlcmshop' src="/images/wlcmshop.png" alt="not found" /> */}
                <img className='wlcmh1sec2' src="/images/hello.png" alt="not found" />
                <img className='wlcmshop' src="/images/desi.png" alt="not found" />
              </div>
              <p className='tellme'>We "THE ROOP SWEETS," have been serving you since 1970 in Bhucho Mandi, District Bathinda (Punjab), where quality speaks louder. We guarantee the best quality in our area. We take proper care of cleanliness. The faith of our customers inspires us to do better for you. So, please do visit us and give us a chance to serve you.</p>
            </div>
          </div>
        </div>

        <div className="marquee-container">
          <div className="marquee">
            <span>ROOP SWEETS OFFERS CAREFULLY CRAFTED DESSERTS THAT BRING THE TRADITIONAL TASTE TO THE NEW AND HEALTH-CONSCIOUS INDIA.</span>
            <span>ROOP SWEETS OFFERS CAREFULLY CRAFTED DESSERTS THAT BRING THE TRADITIONAL TASTE TO THE NEW AND HEALTH-CONSCIOUS INDIA.</span>
            <span>ROOP SWEETS OFFERS CAREFULLY CRAFTED DESSERTS THAT BRING THE TRADITIONAL TASTE TO THE NEW AND HEALTH-CONSCIOUS INDIA.</span>
            <span>ROOP SWEETS OFFERS CAREFULLY CRAFTED DESSERTS THAT BRING THE TRADITIONAL TASTE TO THE NEW AND HEALTH-CONSCIOUS INDIA.</span>
            <span>ROOP SWEETS OFFERS CAREFULLY CRAFTED DESSERTS THAT BRING THE TRADITIONAL TASTE TO THE NEW AND HEALTH-CONSCIOUS INDIA.</span>
          </div>
        </div>



        <ShopKeyPoints />

        <hr className="hrnavbar" />

        <Thankyou />

        <BackGroImg />


        <Footer />
      </div>
    </>
  );
};

export default Aboutus;
